<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { getCookie } from '@/utils/auth'
import { timeFn } from '@/utils/timestamp'
import store from './store'
export default {
  name: 'App',
  mounted () {
    setInterval(() => {
      // 当时间差大于1小时50分钟时，刷新token
      if (timeFn(getCookie('tokentime')) > 110) {
        store.dispatch('refreshToken', { login: getCookie('name'), name: getCookie('nickname') })
      }
    }, 1000 * 60)
  }
}
</script>

<style lang="scss">
#app, body, html {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue